import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  PropTableValues,
  React
};